import { JSX as LocalJSX } from '@ionic/core';
import { IonItem, IonLabel } from '@ionic/react';
import { capitalize } from 'lodash';
import { ReactElement } from 'react';
import { PermissionType } from '../../api/graphql/generated';
import i18n from '../../i18n';
import { getLocalizedText } from '../../i18n/i18n.utils';
import { EntityToLocalizedText } from './role.utils';

interface RolePermissionsFormEntityProps {
  entity: string;
  onSelected: (entity: string) => void;
  itemProps?: LocalJSX.IonItem;
}

const RolePermissionsFormEntity = (
  props: RolePermissionsFormEntityProps
): ReactElement => {
  const { entity, onSelected, itemProps } = props;

  const entityLabel = getLocalizedText(
    EntityToLocalizedText[entity as PermissionType]
  );

  return (
    <IonItem button onClick={() => onSelected(entity)} {...itemProps}>
      <IonLabel>
        {i18n.t('common:role_entity_permissions', {
          entityName: capitalize(entityLabel),
        })}
      </IonLabel>
    </IonItem>
  );
};

export { RolePermissionsFormEntity };
